import React, { useState } from 'react';
import { Row, Col, Button } from '../../bootstrap/index.jsx';
import Tooltip from "../../common/Tooltip.jsx";
import update from "immutability-helper";
import Select from "../../common/Select.jsx";

const DEFAULT_VARIABLES = [
  { key: StringHelper.random(8), name: "a", filters: [] }
];

const AggregateFormFields = ({ indicator: { formula, error_value, operator = "or", variables: defaultVariables }, sourceIndicatorOptions: { indicator_options, filter_options } }) => {
  const [variables, setVariables] = useState(defaultVariables || DEFAULT_VARIABLES);

  const deleteVariable = (i) => {
    if (confirm(I18n.t("confirm_delete_variable"))) {
      setVariables(update(variables, {
        $splice: [[i, 1]],
      }));
    }
  };

  const addVariable = () => {
    let i = 9;
    const chars = [...Array(26)].map((_) => (++i).toString(36)).join``;

    setVariables(update(variables, {
      $push: [{
        key: StringHelper.random(8),
        name: chars[variables.length],
        filters: []
      }]
    }));
  }

  const updateVariable = (i, key, value) => {
    setVariables(update(variables, {
      [i]: {
        [key]: {
          $set: value
        }
      }
    }));
  };

  const addFilter = (i) => {
    setVariables(update(variables, {
      [i]: {
        filters: {
          $push: [{ key: StringHelper.random(8) }]
        }
      }
    }));
  };

  const updateFilter = (variableIndex, filterIndex, key, value, resetSelection) => {
    let operation = {
      [variableIndex]: {
        filters: {
          [filterIndex]: {
            [key]: {
              $set: value
            }
          }
        }
      }
    };

    if (resetSelection) {
      operation[variableIndex].filters[filterIndex].options = { $set: null }
      operation[variableIndex].filters[filterIndex].value = { $set: null }
    }

    setVariables(update(variables, operation));
  };

  const deleteFilter = (variableIndex, filterIndex) => {
    if (confirm(I18n.t("confirm_delete_filter"))) {
      setVariables(update(variables, {
        [variableIndex]: {
          filters: {
            $splice: [[filterIndex, 1]]
          }
        }
      }));
    }
  };

  let variableNames = [];
  let showVariableNameWarning = false;

  const variableElems = variables.map((v, i) => {
    if (v.name) {
      if (variableNames.includes(v.name)) {
        showVariableNameWarning = true;
      }
      variableNames.push(v.name);
    }

    return <div key={v.key || v.id}>
      <div className="d-flex mb-1">
        <input type="hidden" name={`variables[][id]`} value={v.id} />
        <div className="flex-1">
          <input
            type="text"
            name={`variables[][name]`}
            placeholder={I18n.t("variable_name_placeholder")}
            className="form-control"
            defaultValue={v.name}
            onChange={(e) => updateVariable(i, "name", e.target.value)}
          />
        </div>
        <div className="flex-3 pl-1">
          <select
            name={`variables[][indicator_id]`}
            className="form-control"
            defaultValue={v.indicator_id}
            onChange={(e) => updateVariable(i, "indicator_id", e.target.value)}
          >
            <option value="">{I18n.t("select_from_list")}</option>
            {indicator_options.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>
        <div className="flex-2 pl-1">
          <Tooltip title={I18n.t("calculation_variable_value_help")}>
            <input
              type="text"
              name={`variables[][value]`}
              placeholder={I18n.t("calculation_variable_value_placeholder")}
              className="form-control"
              defaultValue={v.value}
            />
          </Tooltip>
        </div>
        <div className="pl-1">
          <Button type="danger" elemType="button" className="small-remove-button" onClick={() => deleteVariable(i)}>
            <span className="icon icon-trash" />
          </Button>
        </div>
      </div>
      {v.filters.map((f, fIdx) => (
        <div key={f.key || (`${f.filter}-${fIdx}`)} className="d-flex mb-1">
          <div className="flex-1"></div>
          <div className="flex-2 pl-1">
            <select name={`variables[][filters][][filter]`} className="form-control" defaultValue={f.filter} onChange={(e) => updateFilter(i, fIdx, "filter", e.target.value, true)}>
              <option value="">{I18n.t("select_from_list")}</option>
              {(filter_options[v.indicator_id] || []).map((g) => (
                <optgroup key={g.label} label={g.label}>
                  {g.options.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>
          <div className="flex-3 pl-1">
            {filter_options[f.filter] ? (
              <Select
                name={`variables[][filters][][options][]`}
                options={filter_options[f.filter]}
                value={f.options || []}
                isMulti
                onChange={(value) => updateFilter(i, fIdx, "options", value)}
              />
            ) : (
              <input
                type="text"
                name={`variables[][filters][][value]`}
                value={f.value || ""}
                className="form-control"
                onChange={(e) => updateFilter(i, fIdx, "value", e.target.value)}
              />
            )}
          </div>
          <div className="pl-1">
            <Button type="danger" elemType="button" className="small-remove-button" onClick={() => deleteFilter(i, fIdx)}>
              <span className="icon icon-trash" />
            </Button>
          </div>
        </div>
      ))}
      <div className="d-flex mb-1">
        <div className="flex-1"></div>
        <div className="flex-3 pl-1">
          <Button elemType="button" size="sm" onClick={() => addFilter(i)}>
            <i className="icon-add"></i> {I18n.t("add_filter")}
          </Button>
        </div>
        <div className="flex-2 pl-1"></div>
        <div className="pl-1" style={{ width: 30 }}></div>
      </div>
    </div>
  });

  return (
    <>
      <Row className="form-group">
        <Col size="xs-12">
          <label className="w-100">
            {I18n.t("formula")}
            <input
              type="text"
              name="formula"
              className="form-control"
              defaultValue={formula}
              placeholder={I18n.t("indicator_formula_placeholder")}
            />
          </label>
        </Col>
      </Row>
      <Row className="form-group">
        <Col size="xs-12">
          <label className="w-100">
            {I18n.t("indicator_error_value_label")}
            <input
              type="text"
              name="error_value"
              className="form-control"
              defaultValue={error_value}
              placeholder={I18n.t("indicator_error_value_placeholder")}
            />
          </label>
        </Col>
      </Row>
      <Row className="form-group">
        <Col size="xs-12">
          <label>{I18n.t("filter_requirement")}</label>
          <div className="checkbox-list">
            <label className="w-100 font-weight-normal">
              <input
                type="radio"
                className="mr-1"
                name="operator"
                defaultChecked={operator == "or"}
                defaultValue="or"
              />
              <span>{I18n.t("require_any")}</span>
            </label>
            <label className="w-100 font-weight-normal">
              <input
                type="radio"
                className="mr-1"
                name="operator"
                defaultChecked={operator == "and"}
                defaultValue="and"
              />
              <span>{I18n.t("require_all")}</span>
            </label>
          </div>
        </Col>
      </Row>
      <Row className="form-group">
        <Col size="xs-12">
          <label className="w-100 mb-0">{I18n.t("variables")}</label>
          {showVariableNameWarning ? (
            <div className="alert alert-warning">
              <i className="fa fa-warning"></i>
              {" " + I18n.t("duplicate_variable_name_warning")}
            </div>
          ) : null}
          {variableElems}
        </Col>
        <Col size="xs-12">
          <Button elemType="button" className="pull-right" onClick={addVariable}>
            <i className="icon-add"></i> {I18n.t("add_variable")}
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default AggregateFormFields;